import { defaultColumns, defaultSort } from '../../components/reports/stockValue/columns';

export default {
  state: {
    stockValue: [],
    tableConfig: null,
    loading: false,
    filterString: null,
    sorting: {
      prop: 'gross_price',
      order: 'desc',
    },
  },
  getters: {
    stockValue: state => state.stockValue,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
  },
  mutations: {
    setStockValue(state, stockValue) {
      state.stockValue = stockValue;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/stock-value-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'stock-value-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const stockValue = await axios.get('api/reports/stock-value' + (query || ''));
        commit('setStockValue', stockValue);
      } catch (e) {
      }
      commit('setLoading', false);
    },
  },
};
